import { useEffect, useState } from 'react';

import DropdownInput from '../../inputs/form-inputs/DropdownInput';
import BuilderPreview from '../../dynamic_entity/BuilderPreview';

import { DynamicEntityStoreProvider } from '../../dynamic_entity/contexts';

const fetchPreview = async (url, body = {}) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching category:', error);
    return null;
  }
};

export default function DynamicPageTemplatePreview({ endpoints, category_values }) {
  const { renderTemplateUrl } = endpoints;

  const [state, setState] = useState({
    selectedCategoryValueID: null,
    content: [],
  });

  useEffect(() => {
    const loadPreview = async () => {
      if (!state.selectedCategoryValueID) return;

      const payload = {
        dynamic_page: {
          category_value_id: state.selectedCategoryValueID,
        },
      };

      const preview = await fetchPreview(`${renderTemplateUrl}.json`, payload);

      if (preview) {
        setState((prevState) => ({
          ...prevState,
          content: preview,
        }));
      } else {
        console.error('Category not found or failed to fetch.');
      }
    };

    loadPreview();
  }, [state.selectedCategoryValueID]);

  return (
    <div className="dp-preview">
      <DropdownInput
        formattedDropdownValues={category_values.map((cv) => ({
          value: cv.id,
          label: cv.title,
        }))}
        value={state.selectedCategoryValueID}
        onChange={(e) => setState((prevState) => ({ ...prevState, selectedCategoryValueID: e.value }))}
        placeholder="Select a category value..."
        isClearable
      />
      <DynamicEntityStoreProvider>
        <BuilderPreview state={state} />
      </DynamicEntityStoreProvider>
    </div>
  );
}
